module.exports = __webpack_public_path__ + "img/officePic1s.393f4299.jpg";